import axios from "axios";
import { useEffect, useState } from "react";
import parse from "html-react-parser";
import '../../src/App.css';


export default function ScContact(){
    const [data, setData] = useState();

    useEffect(() => {
        // axios.get("https://api-als2.nutramax.com/items/sc_external_emergency_contact")
        // .then(response => {
        //     setData(response.data.data);
        // })
        fetch("https://api-als2.nutramax.com/items/sc_external_emergency_contact")
        .then(response => {return response.json()})
        .then(data => {
            setData(data.data);        })
    }, [])
 return (
    <article className="emergency-contact-container">
        <h2 className="emergency-contact-header"> External Emergency Contact </h2> 
        <table> 
            <thead>
            <tr> 
                <th> External Response Organization </th>
                <th> Name </th>
                <th> Phone Number </th>
            </tr>
            </thead>
            {data? data.map(({External_Response_Organization, Name, Phone_Number, id}) => { return (
                <tr key={id}>
                    <td> {External_Response_Organization} </td>
                    <td> {Name} </td>
                    <td> {parse(Phone_Number)} </td>
                </tr>
            )}): null }
        </table>
    </article>
 )
}